import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { NamedEntity } from "../../types"
import { useDeleteNamedEntity, useNamedEntity, useUpdateNamedEntity } from "../../hooks/named-entities"
import { initialValuesNamedEntity, validationSchemaNamedEntity } from "./NamedEntityCommon"
import NamedEntityForm from "./NamedEntityForm"

export default function NamedEntityUpdate() {
  const updateNamedEntity = useUpdateNamedEntity()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: namedEntity } = useNamedEntity(Number(id))

  const deleteNamedEntity = useDeleteNamedEntity()

  const [modalStateDeleteNamedEntity, modalActionsDeleteNamedEntity] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesNamedEntity(namedEntity), [namedEntity])
  const validationSchema = useMemo(() => validationSchemaNamedEntity(), [])

  useBreadcrumbs([{ label: "Entità", href: "/named-entities/named-entities" }, { label: "Dettaglio Entità" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{namedEntity?.name}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteNamedEntity.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return updateNamedEntity.mutateAsync(values as NamedEntity).then(() => {
                navigate(`/named-entities/named-entities`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <NamedEntityForm />
                </Container>
                <BottomFormFixed url="/named-entities/named-entities" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteNamedEntity.isOpen}
        onClose={modalActionsDeleteNamedEntity.close}
        onDelete={() => {
          return deleteNamedEntity.mutateAsync(namedEntity?.id).then(() => {
            navigate(`/named-entities/named-entities`)
          })
        }}
        message="Sei sicuro di voler eliminare questa entità?"
        title="Elimina Entità"
      />
    </Layout>
  )
}
